import { MessageMedium } from 'constants/messageMediums';
import { TemplateEditViews } from 'modules/templateEditor/common';

export const isMediumDesignEnabled = (
  messageMedium: MessageMedium,
  view?: string,
): string | undefined => {
  if (view !== TemplateEditViews.content) return view;
  return view === TemplateEditViews.content &&
    [MessageMedium.Email, MessageMedium.InApp].includes(messageMedium as MessageMedium)
    ? view
    : TemplateEditViews.settings;
};
